import { CircularProgress } from '@civilgrid/ui/components';
import classNames from 'classnames';
import type React from 'react';

interface Props {
  className?: string;
  isLoading?: boolean;
  children?: React.ReactNode;
}

export default function ({ className, isLoading, children }: Props) {
  return (
    <section className={classNames('p-2', className)}>
      {isLoading ? <CircularProgress indeterminate /> : children}
    </section>
  );
}

export const Label = ({ className, children }: Pick<Props, 'className' | 'children'>) => {
  return <div className={classNames('text-base font-semibold', className)}>{children}</div>;
};
